import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { clearWorkspace } from "@somewear/workspace";

import { shapeActions } from "./shape.actions";
import type { IShape } from "./shape.model";
import type { ShapeState } from "./shape.state";

const adapter = createEntityAdapter<IShape>({
	selectId: (shape) => shape.id,
});

export const {
	selectAll: selectAllShapes,
	selectById: selectShapeById,
	selectEntities: selectShapeEntities,
} = adapter.getSelectors((state: ShapeState) => state.shapes);

const shapeSlice = createSlice({
	name: "shapes",
	initialState: adapter.getInitialState(),
	reducers: {
		_: () => {},
	},
	extraReducers: (builder) => {
		builder.addCase(shapeActions.createShape.fulfilled, (state, action) => {
			if (action.payload.data.shape === undefined) return;
			adapter.upsertOne(state, action.payload.data.shape);
		});
		builder.addCase(shapeActions.editShape.fulfilled, (state, action) => {
			const data = action.payload.requestData || action.payload.data?.shape;
			if (data === undefined) return;
			adapter.upsertOne(state, data);
		});
		builder.addCase(shapeActions.getShapes.fulfilled, (state, action) => {
			adapter.upsertMany(state, action.payload.data.shapesList);
		});
		builder.addCase(clearWorkspace, (state, action) => {
			// todo:  this may delete my own shapes
			const deletedItems = adapter
				.getSelectors()
				.selectAll(state)
				.filter((it) => it.workspaceId === action.payload);
			adapter.removeMany(
				state,
				deletedItems.map((it) => it.id),
			);
		});
	},
});

export default shapeSlice;
